module.exports = __webpack_public_path__ + "static/media/icon-bot.4c076c22.svg";